import { useCurrentOrganization } from '@/shared/hooks/organization';
import { ServerWorkspace, Workspace } from '@/shared/types';
import api from '@API/api';
import { useQuery, UseQueryOptions } from 'react-query';
import { mapServerWorkspacePublic } from '@/shared/hooks/workspace/workspaceMapper';

const fetchPublicWorkspaces = (orgId: string): Promise<ServerWorkspace[]> => {
  return api.get(`workspaces/organization/${orgId}/with-public-content`);
};

const useWorkspacesPublicInOrganization = (
  config: UseQueryOptions<Workspace[]> = {}
) => {
  const organization = useCurrentOrganization();

  return useQuery<Workspace[]>({
    ...config,
    queryKey: ['publicWorkspaces', organization?.id],
    queryFn: async () => {
      const workspaces = await fetchPublicWorkspaces(
        organization?.id as string
      );

      return workspaces.map(mapServerWorkspacePublic);
    },
    enabled: !!organization?.id && config?.enabled
  });
};

export default useWorkspacesPublicInOrganization;
